export const t_global_breakpoint_sm = {
  "name": "--pf-t--global--breakpoint--sm",
  "value": "36rem",
  "var": "var(--pf-t--global--breakpoint--sm)"
};
export default t_global_breakpoint_sm;